/**
 * FAIL-CLOSED any-of over a resolved `checkPermission`: `key` alone, or ANY of `key` when it is an
 * array (an empty array holds nothing). For a view that both a `read` ("own") and a `read-all`
 * ("all") holder may open — an "all" role template holds `read-all` alone (ADR-044 §4 amendment).
 *
 * Its own module so a test that mocks `use-permissions` wholesale keeps it.
 */
export function holdsAny(
  checkPermission: (key: string) => boolean,
  key: string | readonly string[],
): boolean {
  return typeof key === 'string' ? checkPermission(key) : key.some(checkPermission);
}
